import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GenericComponent } from './generic.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: '', component: GenericComponent }
    ])
  ],
  exports: [RouterModule]
})
export class GenericRoutingModule { }
